const initialState = {
    data: [],
  };
  
const lokaleReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOKALE':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default lokaleReducer;